import { render, staticRenderFns } from "./employe-detail.vue?vue&type=template&id=ae2f73ae&scoped=true"
import script from "./employe-detail.vue?vue&type=script&setup=true&lang=js"
export * from "./employe-detail.vue?vue&type=script&setup=true&lang=js"
import style0 from "./employe-detail.vue?vue&type=style&index=0&id=ae2f73ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2f73ae",
  null
  
)

export default component.exports